// const APIs = {
//     "proxy": "/",
//     dataURL: {
//         rsisystemy: '/api/rsisystemy',
//         rsigestorzy: '/api/rsigestorzy',
//         rsiobiekty: '/api/rsiobiekty',
//         rsicechy: '/api/rsicechy',
//         v1: '/api'

//     }

// }
const API = process.env.REACT_APP_API_URL;

const APIs = {
    proxy: "http://rsi.stat.intra/api/",
    dataURL: {
        rsisystemy: `${API}/api/rsisystemy`,
        rsigestorzy: `${API}/api/rsigestorzy`,
        rsiobiekty: `${API}/api/rsiobiekty`,
        rsicechy: `${API}/api/rsicechy`,
        v1: `${API}/api/api`,
    },
};

export default APIs;
